import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import Styles from './UserManualLabs.module.scss';
import { UserManual } from 'components/UserManual/UserManual';
import FeatherIcon from 'feather-icons-react';
import { useAPI } from 'components/lib';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';
import { BreadCrumbs } from 'components/global/BreadCrumbs/BreadCrumbs';

const UserManualNodes = (props) => {
    const { lab_id } = useParams();
    const [downloadOpen, setDownloadOpen] = useState(false);
    const [lectureProgress, setLectureProgress] = useState(0);
    const [labName, setLabName] = useState('');

    const { data, loading } = useAPI(`/api/labs/${lab_id}/localsetup`);

    useEffect(() => {

        if (data) {
            setLabName(data.lab_name || '');
            document.title = props.t('Labs.UserManualLabs.title', { labName: data.lab_name })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    const handleDownloadClick = () => {
        setDownloadOpen(true);
    };

    function userManualNavigate(direction) {
        switch (direction) {
            case 'prev':
                setLectureProgress(lectureProgress - 1);
                break;
            case 'forward':
                setLectureProgress(lectureProgress + 1);
                break;
            default:
                break;
        }
    }

    return (
        <>
            {loading ? (
                <div>
                    <LoadingBackdrop isOpen={true} />
                </div>
            ) : (
                <>
                    <BreadCrumbs
                        onClickPaths={['/labs', `/labs/${lab_id}/nodes`, '']}
                        crumbs={[
                            props.t('Labs.UserManualLabs.breadcrumbs.labs'),
                            labName ? `${labName}: ${props.t('Labs.UserManualLabs.breadcrumbs.nodes')}` : props.t('Labs.UserManualLabs.breadcrumbs.nodes'),
                            labName ? `${labName}: ${props.t('Labs.UserManualLabs.breadcrumbs.usermanual')}` : props.t('Labs.UserManualLabs.breadcrumbs.usermanual'),
                        ]}
                    />
                    <div className={Styles.userManualContainer}>

                        <div className={Styles.slideHeader}>
                            <p>SLIDE: {lectureProgress + 1}/{data?.content.length}</p>
                            <button onClick={handleDownloadClick}>
                                <FeatherIcon icon='download' />
                            </button>
                        </div>
                        <UserManual
                            data={data?.content.length && data.content[lectureProgress]}
                            callback={userManualNavigate}
                            currentIndex={lectureProgress}
                            totalSteps={data?.content.length}
                        />
                    </div>

                    <Dialog open={downloadOpen} maxWidth={false} onClose={() => setDownloadOpen(false)}>
                        <DialogTitle>
                            <ReactToPrint
                                copyStyles={true}
                                content={() => document.getElementById('userManual')}
                                onAfterPrint={() => setDownloadOpen(false)}
                                documentTitle={props.t('Labs.UserManualLabs.download.title', { labName: labName })}
                            >
                                <PrintContextConsumer>
                                    {({ handlePrint }) => (
                                        <button
                                            id='confirmDownload'
                                            className={Styles.confirmDownload}
                                            onClick={handlePrint}
                                        >
                                            {props.t('Labs.UserManualLabs.download.button')}
                                        </button>
                                    )}
                                </PrintContextConsumer>
                            </ReactToPrint>
                        </DialogTitle>
                        <DialogContent className={Styles.printContent} id='userManual'>
                            <div className={Styles.centeredContent}>
                                {data?.content.map((cont, index) => (
                                    <UserManual
                                        key={cont.title}
                                        data={cont}
                                        title={cont.title}
                                        showNavigate={false}
                                        description={cont.description}
                                        imageUrl={cont.imageUrl}
                                        steps={cont.steps}
                                    />
                                ))}
                            </div>
                        </DialogContent>
                    </Dialog>
                </>
            )}
        </>
    );
};

export default UserManualNodes;
